export const AttributeTypeEnum = [
    { id: 'text', name: 'Text' },
    { id: 'textarea', name: 'Textarea' },
    { id: 'yes_no', name: 'Yes/No' },
    { id: 'select', name: 'Select' },
    { id: 'multiselect', name: 'Multiselect' },
    { id: 'checkbox', name: 'Checkbox' },
    { id: 'radio', name: 'Radio' },
    { id: 'datetime', name: 'Datetime' },
    { id: 'price', name: 'Price' },
    { id: 'number', name: 'Number' }
];

export const AttributeOptionType = [
    'select',
    'multiselect',
    'checkbox',
    'radio',
];